import { ResponseEnvelope } from './response-envelope';
import { InheritedDoc } from 'typescript-openapi-router';

@InheritedDoc()
export class S3EventResponseBody extends ResponseEnvelope {}
